import './style/index.less';
import PluginDeptSelect from './PluginDeptSelect';

export default PluginDeptSelect;
